import React, { useEffect, useRef } from 'react';
import { showErrorMsg } from '../../../../utils/notifications';
import tikIcon from '../../../../assets/images/tik_icon.svg';
import analytics from '../../../../utils/analytics';
import './style.css';

const SubscriptionPopup = ({ 
  isOpen, 
  onClose, 
  onSuccess, 
  subscriptionPlans = [], 
  selectedPlan, 
  setSelectedPlan, 
  loading, 
  onSubscribe,
  isSubscribed = false
}) => {
  const paymentSuccessRef = useRef(false);
  
  // Track when popup is shown
  useEffect(() => {
    // Reset payment success flag when popup opens
    paymentSuccessRef.current = false;
  }, [isOpen]);
  
  useEffect(() => {
    if (isOpen) {
      analytics.trackPlatformEvent('subscription_popup_shown', {
        popup_type: 'free_limit_reached',
        has_plan_selected: !!selectedPlan,
        plan_count: subscriptionPlans.length,
        is_subscribed: isSubscribed
      });
    }
  }, [isOpen, selectedPlan, subscriptionPlans.length, isSubscribed]);

  const handleSubscribe = () => {
    if (!selectedPlan) {
      showErrorMsg('Please select a subscription plan');
      return;
    }
    
    // Track subscription button click
    analytics.trackPlatformEvent('subscription_popup_subscribe_clicked', {
      plan_text: selectedPlan.text,
      plan_final_amount: selectedPlan.final_amount,
      plan_discount: selectedPlan.discount,
      is_subscribed: isSubscribed
    });
    
    onSubscribe();
    
    // Set success flag to track if payment completes
    paymentSuccessRef.current = true;
  };

  const handleClose = () => {
    // Only track manual dismissal
    if (!paymentSuccessRef.current) {
      analytics.trackPlatformEvent('subscription_popup_closed', {
        had_plan_selected: !!selectedPlan,
        is_subscribed: isSubscribed,
        close_reason: 'user_dismissed'
      });
    }
    // Success events are tracked in SubscriptionGateProvider
    
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="subscription-popup-overlay">
      <div className="subscription-popup">
        {/* Crown Icon */}
        <div className="subscription-popup-crown-container">
          <div className="subscription-popup-crown-outer">
            <div className="subscription-popup-crown-inner">
              <img src="/images/subscription_crown.svg" alt="Crown" className="subscription-popup-crown-image" />
            </div>
          </div>
        </div>

        {/* Title */}
        <h1 className="subscription-popup-title">Pukaar AI  Premium</h1>

        <p className="subscription-popup-description">
        Your Free Feature Access has Expired. Subscribe to continue
        </p>

        {/* Trial Offer Card - Same as Subscription Page */}
        {selectedPlan && (
          <div className="subscription-popup-trial-card">
            <div className="subscription-popup-plan-text">
              <div>
                Get <strong>{selectedPlan.text}</strong> Premium Trial
              </div>
            </div>
            <div className="subscription-popup-plan-pricing">
              {selectedPlan.discount > 0 && (
                <div className="subscription-popup-plan-original-price">
                  ₹{selectedPlan.actual_amount}
                </div>
              )}
              <div className="subscription-popup-plan-final-price">
                ₹{selectedPlan.final_amount}
              </div>
            </div>
            {selectedPlan.discount > 0 && (
              <div className="subscription-popup-plan-discount-badge">
                Save {selectedPlan.discount}%
              </div>
            )}
          </div>
        )}

        {/* Features List */}
        <div className="subscription-popup-features">
          <div className="subscription-popup-feature">
            <div className="subscription-popup-checkmark">
              <img src={tikIcon} alt="Check" className="subscription-popup-tik-icon" />
            </div>
            <span>Unlimited Cry Analysis</span>
          </div>
          <div className="subscription-popup-feature">
            <div className="subscription-popup-checkmark">
              <img src={tikIcon} alt="Check" className="subscription-popup-tik-icon" />
            </div>
            <span>Unlimited QARA chats</span>
          </div>
          <div className="subscription-popup-feature">
            <div className="subscription-popup-checkmark">
              <img src={tikIcon} alt="Check" className="subscription-popup-tik-icon" />
            </div>
            <span>Priority Expert Consultations</span>
          </div>
          <div className="subscription-popup-feature">
            <div className="subscription-popup-checkmark">
              <img src={tikIcon} alt="Check" className="subscription-popup-tik-icon" />
            </div>
            <span>Full access to Support</span>
          </div>
        </div>

        {/* Subscribe Button */}
        <button 
          className="subscription-popup-subscribe-btn"
          onClick={handleSubscribe}
          disabled={!selectedPlan || loading}
        >
          {loading ? 'Processing...' : 'Subscribe Now'}
        </button>

        {/* Close Button */}
        <button className="subscription-popup-close-btn" onClick={handleClose}>
          ×
        </button>
      </div>
    </div>
  );
};

export default SubscriptionPopup;
